import logoSmall from '@stack/assets/images/logo-icon.svg';
import logoSmallLight from '@stack/assets/images/logo-icon-light.svg';
import logo from '@stack/assets/images/logo-text.svg';
import logoLight from '@stack/assets/images/logo-text-light.svg';
import { useThemeSettings } from '@webbyx/mui';
import Image from 'next/image';

import { LogoProps } from './props';

/**
 * ===========================
 * MAIN
 * ===========================
 */
export const Logo: React.FC<LogoProps> = (props) => {
  const { type = 'normal', ...restProps } = props;
  const { settings } = useThemeSettings();
  // =============== VIEWS
  if (type === 'small') {
    return (
      <Image
        src={settings.mode === 'light' ? logoSmall : logoSmallLight}
        priority
        {...restProps}
      />
    );
  }

  return (
    <Image
      src={settings.mode === 'light' ? logo : logoLight}
      priority
      {...restProps}
    />
  );
};

/**
 * ===========================
 * EXPORTS
 * ===========================
 */
export * from './props';
export default Logo;
